<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header">
                    <h3 class="page-title">{{ $t('words.media_profile_groups') }}<span class="text-tooltip v-tooltip-open" v-tooltip="{ content: $t('paragraphs.profile.group_tip1') + '<br>' + $t('paragraphs.profile.group_tip2') }"><i class="icon icon-info-circle-line"></i></span></h3>
                </div>
            </div>
            <div class="page-body">
                <table class="table table__module">
                    <thead>
                    <tr>
                        <th rowspan="2" class="td-border-right td__minimize">{{ $t('words.quality') }}</th>
                        <th rowspan="2" class="td-border-right td__minimize">{{ $t('words.key') }}</th>
                        <th colspan="3" class="td-border-right text-center">{{ $t('words.video') }}</th>
                        <th colspan="2" class="td-border-right text-center">{{ $t('words.audio') }}</th>
                        <th rowspan="2" class="td__minimize">{{ $t('words.use_yes_no') }}</th>
                    </tr>
                    <tr>
                        <th>{{ $t('words.codec') }}</th>
                        <th>{{ $t('words.resolution') }}</th>
                        <th class="td__bitrate td-border-right text-right">{{ $t('words.bitrate') }}<small>kbps</small></th>
                        <th>{{ $t('words.codec') }}</th>
                        <th class="td__bitrate td-border-right text-right">{{ $t('words.bitrate') }}<small>kbps</small></th>
                    </tr>
                    </thead>
                    <tbody v-if="total > 0">
                    <tr v-for="profile in profileGroup.data.profiles" :key="profile.encoded_id">
                        <td class="td-border-right"><span :class="`badge badge__profile__${profile.name.replace(/p$/,'')}`">{{ profile.name }}</span></td>
                        <td class="td-border-right">{{ profile.key }}</td>
                        <td class="td__video__codec"><span v-if="profile.key === 'passthrough'">passthrough</span><span v-else>{{ profile.video_codec }}</span></td>
                        <td class="td__video__width"><span v-if="profile.key === 'passthrough'">passthrough</span><span v-else>{{ profile.video_width }}x{{ profile.video_height }}</span></td>
                        <td class="td__bitrate td-border-right text-right"><span v-if="profile.key === 'passthrough'">passthrough</span><span v-else>{{ profile.video_bitrate }}</span></td>
                        <td class="td__audio__codec"><span v-if="profile.key === 'passthrough'">passthrough</span><span v-else>{{ profile.audio_codec }}</span></td>
                        <td class="td__bitrate td-border-right text-right"><span v-if="profile.key === 'passthrough'">passthrough</span><span v-else>{{ profile.audio_bitrate }}</span></td>
                        <td class="td__minimize">
                            <toggle-button v-model="profile.is_used" :sync="true" @change="ChangeStatus(profile)" :disabled="!haveOwnerRight"></toggle-button>
                            <!--<span v-if="profile.is_used">{{ $t('words.use_yes') }}</span>-->
                            <!--<span v-else>{{ $t('words.use_no') }}</span>-->
                            <!--<div class="form-check form-check-inline">-->
                            <!--<label class="form-check-label">-->
                            <!--<input type="radio" :value="true" class="form-check-input" @click="doAttach(profile)" v-model="profile.is_used" :disabled="profileGroup.data.has_onair_channel">-->
                            <!--{{ $t('words.use_yes') }}-->
                            <!--</label>-->
                            <!--</div>-->
                            <!--<div class="form-check form-check-inline">-->
                            <!--<label class="form-check-label">-->
                            <!--<input type="radio" :value="false" class="form-check-input" @click="doDetach(profile)" v-model="profile.is_used" :disabled="profileGroup.data.has_onair_channel">-->
                            <!--{{ $t('words.use_no') }}-->
                            <!--</label>-->
                            <!--</div>-->
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr><td colspan="8" class="td__message">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.profile.list_empty') }}</td>
                    </tr>
                    </tbody>
                </table>
                <router-link :to="{ name: 'cms-preferences-profile-groups' }" class="btn mt-sp">{{ $t('words.list') }}</router-link>
            </div>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';

export default {
    mixins: [
        GlobalConfigMixin,
    ],
    props: {
        profile_group_id: {
            type: [String, Number],
            require: true,
        },
    },
    data() {
        return {
            profileGroup: {},
            total: 0,
        };
    },
    mounted() {
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            this.loadProfiles(this.profileApiUri);
        },
        ChangeStatus(profile) {
            if (profile.is_used) {
                this.doAttach(profile);
            } else {
                this.doDetach(profile);
            }
        },
        loadProfiles(profileApiUri) {
            axios.get(profileApiUri).then((response) => {
                this.profileGroup = response.data;
                this.total = this.profileGroup.data.profiles.length;
            });
        },

        doAttach(profile) {
            const lProfile = Object.create(profile);
            axios.put(`${this.profileApiUri}/attach/${lProfile.encoded_id}`).then(() => {
                this.$toasted.success(this.$t('paragraphs.message.success.update'));
            }).catch((error) => {
                lProfile.is_used = false;
                this.$toasted.error(error.response.data.message);
            });
        },
        doDetach(profile) {
            const lProfile = Object.create(profile);
            axios.put(`${this.profileApiUri}/detach/${lProfile.encoded_id}`).then(() => {
                this.$toasted.success(this.$t('paragraphs.message.success.update'));
            }).catch((error) => {
                lProfile.is_used = true;
                this.$toasted.error(error.response.data.message);
            });
        },
    },
    computed: {
        profileApiUri() {
            return `/cms/${this.selectedServiceAccount.key}/profile_groups/${this.profile_group_id}`;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
        // selectedServiceAccount(newValue, oldValue) {
        //     if (typeof oldValue.key !== 'undefined' && newValue.key !== oldValue.key) {
        //         this.$router.push({ name: 'cms-preferences-profile-groups' });
        //     }
        // },
    },
};
</script>
